import { useTranslation } from "react-i18next";
import Icon from "../components/Icon";
import Reveal from "../components/Reveal";
import { scrollToSection } from "../lib/navigation";

export default function Hero() {
  const { t } = useTranslation();
  const go = (id) => (event) => {
    event.preventDefault();
    scrollToSection(id);
  };

  return (
    <section className="fsg-hero" id="inicio">
      <span className="fsg-glow fsg-glow--a" aria-hidden="true" />
      <span className="fsg-glow fsg-glow--b" aria-hidden="true" />
      <span className="fsg-grid-pattern" aria-hidden="true" />

      <div className="fsg-container">
        <div className="fsg-hero__grid">
          <Reveal>
            <h1
              className="fsg-hero__title"
              /* Cadena estática propia: solo aporta <em> y el salto de línea. */
              dangerouslySetInnerHTML={{ __html: t("hero.title") }}
            />
            <p className="fsg-hero__lead">{t("hero.lead")}</p>

            <div className="fsg-btn-row">
              <a
                className="fsg-btn fsg-btn--primary fsg-btn--lg"
                href="#contacto"
                onClick={go("contacto")}
              >
                {t("cta.primaryLong")}
                <Icon name="arrow" />
              </a>
              <a
                className="fsg-btn fsg-btn--ghost fsg-btn--lg"
                href="#herramientas"
                onClick={go("herramientas")}
              >
                <Icon name="sparkles" />
                {t("recommender.title")}
              </a>
            </div>

            <p
              className="fsg-hint"
              style={{ marginTop: "var(--fsg-s-3)" }}
            >
              {t("hero.ctaNote")}
            </p>

          </Reveal>

          <Reveal className="fsg-hero__visual" delay={120}>
            <div className="fsg-hero__photo">
              <img
                src="/images/banner.jpeg"
                alt="Equipo de Financial Support Group"
                width={2048}
                height={1365}
              />
            </div>

          </Reveal>
        </div>
      </div>
    </section>
  );
}
